import { useCallback, useState } from "react";

const useToggle = (status = false) => {
  const [open, setOpen] = useState(status);

  // Stable, so it can sit in an effect's dependencies.
  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const shouldRender = open;

  return {
    open,
    toggle,
    shouldRender,
  };
};

export default useToggle;
